import React from "react";
import Price from "../price/Price";

export default function InfoDrink({
  quantity,
  alcoholPercentage,
  categoryIcon,
  price,
  isAvailable,
}) {
  return (
    <div className="flex justify-between items-start bg-[#1f1f1f] border border-gray-700 rounded-xl p-4 shadow-md text-sm text-gray-300">
      {/* Quantità */}
      <div className="flex-1 text-left">
        <h3 className="text-gray-100 font-semibold text-base mb-1">Capienza</h3>
        <p>{quantity || "-"}</p>
      </div>

      {/* Prezzo */}
      <div className="flex-1 text-center">
        <Price price={price} isAvailable={isAvailable} categoryIcon={categoryIcon} />
      </div>

      {/* Gradazione */}
      <div className="flex-1 text-right">
        <h3 className="text-gray-100 font-semibold text-base mb-1">Vol.</h3>
        <p>{alcoholPercentage || "-"}</p>
      </div>
    </div>
  );
}
